import { useEffect, useState } from 'react';
import { useContracts } from './useContracts';
import { useWallet } from '../context/WalletContext';
import { useUserData } from './useUserData';

// Reads the on-chain circular activity buffer via GRXPlanViews.getActivities.
// Returns newest-first list capped at LIMIT.
const LIMIT = 25;
const POLL_MS = 30000;

export const useRecentActivity = () => {
  const { account } = useWallet();
  const c = useContracts();
  const { userId } = useUserData();
  const [state, setState] = useState({ loading: true, events: [] });

  useEffect(() => {
    let mounted = true;
    let timer;
    const load = async () => {
      if (!account || !userId || userId === 0n) {
        if (mounted) setState({ loading: false, events: [] });
        return;
      }
      try {
        const list = await c.read.views.getActivities(userId, LIMIT);
        // Contract returns oldest-first within the page; reverse for newest-first.
        const events = [...list].reverse().map((a) => ({
          actType:   Number(a.actType),
          amount:    BigInt(a.amount),
          netAmount: BigInt(a.netAmount),
          relatedId: BigInt(a.relatedId),
          ts:        Number(a.timestamp),
        }));
        if (mounted) setState({ loading: false, events });
      } catch (e) {
        if (mounted) setState({ loading: false, events: [] });
      }
    };
    load();
    timer = setInterval(load, POLL_MS);
    return () => { mounted = false; clearInterval(timer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, userId]);

  return state;
};
